import { useRoutes } from "react-router-dom";
import React, { useState } from 'react';
import CreateCard from "../../Component/CreateCard.js"

import CacheClear from './cacheClear.js';
import Permistion from './Permistion.js';
import Sample from './sampleRole.js';
import MasterPassword from './ChangePassword.js'

const MarketingManagementCardArray = [
  {
    title: "Cache Clear for label",
    path: "cacheClear",
    auth: "user",
  },
  {
    title: "Permistion",
    path: "permistion",
    auth: "user",
  },
  {
    title: "Master User password Change",
    path: "passwordChange",
    auth: "user",
  },
  {
    title: "test Sample",
    path: "test",
    auth: "user",
  }
]
const MarketingManagementRoutesArray = [
  {
    path: "/",
    element: <CreateCard cardJson={[...MarketingManagementCardArray]} />
  },
  {
    path: "*",
    element: <>This is 404</>
  },
  {
    path: "cacheClear/*",
    element: <CacheClear />
  },
  {
    path: "permistion/*",
    element: <Permistion />
  },
  {
    path: "test/*",
    element: <Sample />
  },
  {
    path: "passwordChange/*",
    element: <MasterPassword />
  }

]

function AdminRoutes() {
  return useRoutes(MarketingManagementRoutesArray)
}

// export default function Routes() {
//     const [password, setPassword] = React.useState('');
//     const [msg, setMsg] = React.useState('')
//     const [isAuthenticated, setIsAuthenticated] = React.useState(false);

//       // Function to get the current time in HHMMSS format
//   const getCurrentTimePassword = () => {
//     const current = new Date();
//     const hours = String(current.getHours()).padStart(2, '0'); // 2 digits hours
//     const minutes = String(current.getMinutes()).padStart(2, '0'); // 2 digits minutes
//     // const seconds = String(current.getSeconds()).padStart(2, '0'); // 2 digits seconds
//     return `${hours}${minutes}`; // Password is like HHMMSS
//   };

//     const handlePasswordSubmit = () => {
//       const currentTimePassword = getCurrentTimePassword();
//       console.log(currentTimePassword)
//         if (password === currentTimePassword) { // Replace 'your_password_here' with the actual password
//           setIsAuthenticated(true);
//           setMsg('');
//         } else {
//           setMsg('Incorrect password');
//         }
//       };

//     return (
//         <div className='main'>
//         {!isAuthenticated ? (
//         <div>
//           <input
//             type="password"
//             placeholder="Enter password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={{
//               marginRight: '10px',
//               padding: '10px 20px',
//               fontSize: '16px',
//               borderRadius: '20px',
//               border: '1px solid #1a94f5',
//               outline: '1px solid #1a94f5',
//             }}
//           />
//           <button
//             onClick={handlePasswordSubmit}
//             style={{
//               padding: '10px 20px',
//               fontSize: '16px',
//               cursor: 'pointer',
//               borderRadius: '20px',
//               background: '#86bbe5',
//               border: '1px solid #1a94f5',
//               color: '#fff',
//             }}
//           >
//             Submit
//           </button>
//           <p style={{ fontSize: '18px', color: 'red' }}>{msg}</p>
//         </div>
//       ) : (
//         <AdminRoutes/>
//       )
//       }
//         </div>
//     )
// }

export default function Routes() {
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [msg, setMsg] = useState("");

  // Function to get the current time in HHMM format
  const getCurrentTimePassword = () => {
    const current = new Date();
    const hours = String(current.getHours()).padStart(2, '0'); // 2 digits hours
    const minutes = String(current.getMinutes()).padStart(2, '0'); // 2 digits minutes
    return `${hours}${minutes}`; // Password is like HHMM
  };

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (/^\d$/.test(value) || value === "") { // Only accept single digits
      const newOtp = [...otp];
      newOtp[index] = value;

      // Move focus to the next input field
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmit = () => {
    const currentTimePassword = getCurrentTimePassword();
    const enteredPassword = otp.join(""); // Combine OTP digits to a single string

    if (enteredPassword === currentTimePassword) {
      setIsAuthenticated(true);
      setMsg('');
    } else {
      setMsg('Incorrect OTP');
    }
  };

  return (
    <div className='main'>
      {!isAuthenticated ? (
        <div style={{
          width: '50%',
          marginLeft: 'auto',
          marginRight: 'auto',
          placeContent: 'center',
          display: "grid"
        }}>
          <div style={{
            padding: '15px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            borderRadius: '4px'
          }}>
            <h3>OTP Verification</h3>
            <div style={{ display: "flex", gap: "10px", marginLeft: '16px'}}>
              {otp.map((_, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  value={otp[index]}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  maxLength="1" // Only allow single character input
                  style={{
                    width: '40px',
                    height: '40px',
                    textAlign: 'center',
                    fontSize: '18px',
                    borderRadius: '8px',
                    border: '1px solid #1a94f5',
                    outline: 'none',
                    padding: '10px',
                  }}
                />
              ))}
            </div>
            <button
              onClick={handleSubmit}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                cursor: 'pointer',
                borderRadius: '20px',
                background: '#86bbe5',
                border: '1px solid #1a94f5',
                color: '#fff',
                marginTop: '10px',
                width:'100%'
              }}
            >
              Submit
            </button>
            <p style={{ fontSize: '18px', color: 'red' }}>{msg}</p>
          </div>
        </div>
      ) : (
        <AdminRoutes />
      )}
    </div>
  );
}